<template>
  <HvhModal title="Table Columns" :value="true" persistent maxWidth="80%" @input="$emit('close')">
    <div class="hvh-flex space-between overflow-hidden max-height">
      <div class="border overflow-auto col-5">
        <DragItem class="hvh-flex" @drag-start="draggingItem = item" @drag-stop="draggingItem = null" v-for="item in forPickColumns" :key="item.name">
          {{ item.name }}
        </DragItem>
      </div>
      <DropZone class="border overflow-auto col-5" :item="draggingItem" @input="itemDropped" @hover="itemHover">
        <div class="drop-position" :class="{ selected: draggingItem && dropPosition === 0 }" />
        <template v-for="(item, ind) in pickedColumns">
          <div class="hvh-flex space-between" :key="item.name" ref="dropItems">
            <DragItem class="hvh-flex" :disabled="true" @drag-start="draggingItem = item" @drag-stop="draggingItem = null">
              {{ item.name }}
            </DragItem>
            <v-icon @click="unselectItem(item)">mdi-close</v-icon>
          </div>
          <div class="drop-position" :class="{ selected: draggingItem && dropPosition === ind + 1 }" :key="`span-${ind}`" />
        </template>
      </DropZone>
    </div>

    <template v-slot:actions>
      <v-btn flat class="hvh-btn hvh-btn--secondary m-0" @click="$emit('close')">Cancel</v-btn>
      <v-btn flat class="hvh-btn hvh-btn--primary m-0 ml-3" @click="$emit('input', pickedColumns)">Save</v-btn>
    </template>
  </HvhModal>
</template>

<script>
import DropZone from '../common/drag/DropZone.vue';
import DragItem from '../common/drag/DragItem.vue';
export default {
  components: { DropZone, DragItem, },
  props: ['value', 'items'],
  data() {
    return {
      draggingItem: null,
      dropPosition: null,
      pickedColumns: [...(this.value || [])],
    }
  },
  computed: {
    forPickColumns() {
      var pickedColumns = this.pickedColumns.reduce((acc, f) => { acc[f.name] = true; return acc; }, {});
      return this.items.filter(f => !pickedColumns[f.name]);
    },
  },
  methods: {
    getPosition(event) {
      var dropItems = (this.$refs.dropItems || []).map(el => el.getBoundingClientRect());
      var position = dropItems.filter(f => f.y < event.clientY).length;
      return position;
    },
    itemHover(item, event) {
      this.dropPosition = item && this.getPosition(event);
    },
    itemDropped(item, event) {
      setTimeout(() => {
        this.dropPosition = null;
        var position = this.getPosition(event);
        var duplicates = this.pickedColumns.filter((f, ind) => ind < position && f.name === item.name);
        position -= duplicates.length;

        this.pickedColumns = this.pickedColumns.filter(f => f.name !== item.name);
        this.pickedColumns.pushAt(position, item);
      }, 100);
    },
    unselectItem(item) {
      this.pickedColumns = this.pickedColumns.filter((f) => f.name !== item.name);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSelecter'] = this;
  }
}
</script>

<style lang="scss" scoped>
.drop-position {
  height: 5px;
  &.selected {
    background-color: lightgray;
  }
}

.border {
  border: 1px solid lightgray;
}

.max-height {
  max-height: 50vh;
}
</style>